import Backdrop from '@mui/material/Backdrop';
import {Box, Typography  } from '@mui/material';

const textStyle = {
    color: 'white',
    marginRight: '2em',
    marginLeft: '2em',
    fontSize: '18px',
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 'bold',
};

const FlipPhone = () => {

    return (
        <Backdrop
            sx={{
                color: '#ffffffff',
                zIndex: 20,
                height: '100vh',
                width: '100vw',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'absolute',
                backgroundColor: '#333333',
                top: 0,
                left: 0,
            }}
            open={true}
        >
            <Box>
                <Typography variant="body1" gutterBottom style={{...textStyle}}>
                    Please turn your phone to landscape mode
                </Typography>
            </Box>
            </Backdrop>
    )
};

export default FlipPhone